import { Box, Text } from '@wix/design-system';
import React from 'react';
export const MobileStatusBox = _ref => {
  let {
    datahook,
    children,
    transparent = false
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    textAlign: "center",
    padding: "SP5 SP3 SP3 SP3",
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
    transform: "translateY(-8px)",
    backgroundColor: transparent ? undefined : '#F7F5F3',
    dataHook: datahook
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, children));
};
//# sourceMappingURL=MobileStatusBox.js.map